import { postCall, getCall, putCall, deleteCall } from "./api";

//Machine

export const addMachine = async (input = {}) => {
  return await postCall({ path: `/asset/machine`, bodyParams: input, });
};

export const getMachineData = async () => {
  return await getCall({ path: `/asset/machines`, });
};

export const updateMachine = async (id, input = {}) => {
  return await putCall({ path: `/asset/${id}/machine`, bodyParams: input, });
};

//Software

export const addSoftware = async (input = {}) => {
  return await postCall({ path: `/asset/software`, bodyParams: input, });
};
  
export const getSoftwareData = async () => {
  return await getCall({ path: `/asset/software`, });
};

export const updateSoftware = async (id, input = {}) => {
  return await putCall({ path: `/asset/${id}/software`, bodyParams: input, });
};

// Common

// Every asset, machines and software alike. The overview counts a fleet, and a
// fleet split across two calls cannot be counted without double-fetching.
export const getAllAssets = async () => {
  return await getCall({ path: `/asset`, });
};

export const getAssetById = async (id) => {
  return await getCall({ path: `/asset/${id}`, });
};

export const deleteAsset = async (id) => {
  return await deleteCall({ path: `/asset/${id}`, });
};


// ---- vendors (suppliers an asset was bought from or is serviced by) ----
export const getVendors = async (activeOnly) =>
  await getCall({ path: `/vendor${activeOnly ? "?active=true" : ""}` });
export const createVendor = async (input = {}) =>
  await postCall({ path: `/vendor`, bodyParams: input });
export const updateVendor = async (id, input = {}) =>
  await putCall({ path: `/vendor/${id}`, bodyParams: input });
// deactivated, not deleted — assets keep their link to a retired supplier
export const deactivateVendor = async (id) =>
  await postCall({ path: `/vendor/${id}/deactivate`, bodyParams: {} });

// ---- moving an asset between legal entities ----
//
// Not part of updateMachine/updateSoftware on purpose: the server refuses a
// legalUnit in a plain update and points here, because which company owns an
// asset is a balance-sheet fact and the move is recorded with a reason.

// { legalUnit, reason, note?, effectiveDate? } — reason is required.
export const transferAsset = async (id, input = {}) =>
  await putCall({ path: `/asset/${id}/transfer`, bodyParams: input });

export const getAssetTransfers = async (id) =>
  await getCall({ path: `/asset/${id}/transfers` });
